import React, { useEffect, useState } from "react";
import {
  Card,
  Container,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import DeleteModal from "./deletepopup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa";
import { getActivity, deleteActivity } from "../../store/slices/activity";

export default function Activity() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const {
    activityList = [],
    loading,
    totalDataCount = 0,
  } = useSelector((state) => state.activity);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const [currentPage, setCurrentPage] = useState(1);
  const pagelimit = 10;

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim());
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const params = {
      page: currentPage,
      limit: pagelimit,
    };

    if (debouncedSearch) {
      params.search = debouncedSearch;
    }

    dispatch(getActivity(params));
  }, [dispatch, currentPage, debouncedSearch]);

  const paginatedData = activityList;
  const totalPages = Math.ceil(totalDataCount / pagelimit);


  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deleteActivity(selectedId)).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/activity")}
          >
            Activity
          </span>
        </div>

        <button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/addactivity")}
        >
          + Add Activity
        </button>
      </div>

      {/* Table Section */}
      <Container>
        <Card className="table-border mb-5">
          <Card.Body>
            <div className="common-table-wrapper">
              <div className="d-flex gap-2 mb-3 ms-2 mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search name"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ maxWidth: "250px" }}
                />



                <button
                  className="cancel-btn"
                  onClick={() => {
                    setSearch("");

                  }}
                >
                  Reset
                </button>
              </div>
              <table className="common-table">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Image</th>
                    <th className="text-center">Activity Name</th>
                    {/* <th className="text-center">Price Range</th> */}
                    {/* <th>Locations</th> */}
                    <th className="text-center">Description</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading
                    ? [...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-image"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                    : paginatedData.map((item, index) => (
                      <tr key={item._id}>
                        <td className="text-center">
                          {(currentPage - 1) * pagelimit + index + 1}
                        </td>

                        <td className="text-center">
                          {item.image ? (
                            <img
                              src={item.image}
                              alt={item.name}
                              style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "6px",
                              }}
                            />
                          ) : (
                            <span className="no-image">—</span>
                          )}
                        </td>

                        {/* Name */}
                        <td className="text-center">{item.name}</td>

                        <td
                          style={{
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-${item.id}`}>
                                {item.description}
                              </Tooltip>
                            }
                          >
                            <span style={{ cursor: "pointer" }}>
                              {item.description}
                            </span>
                          </OverlayTrigger>
                        </td>

                        {/* Actions */}
                        <td className="text-center">
                          <div className="action-btn-group">
                            <button
                              className="action-btn edit-btn"
                              onClick={() =>
                                navigate(`/admin/editactivity/${item._id}`)
                              }
                            >
                              <FaEdit size={14} />
                            </button>

                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(item._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {!loading && totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 mt-4 flex-wrap">

                <Button
                  variant="light"
                  disabled={currentPage === 1}
                  onClick={() =>
                    setCurrentPage(currentPage - 1)
                  }
                >
                  ‹
                </Button>


                {Array.from(
                  { length: totalPages },
                  (_, i) => i + 1
                )
                  .filter((page) => {

                    return (
                      page === 1 ||
                      page === totalPages ||
                      Math.abs(page - currentPage) <= 1
                    );

                  })
                  .map((page, index, arr) => {

                    const prevPage = arr[index - 1];

                    return (
                      <div
                        key={page}
                        className="d-flex align-items-center gap-2"
                      >

                        {/* DOTS */}
                        {
                          prevPage &&
                          page - prevPage > 1 && (
                            <span>...</span>
                          )
                        }

                        <Button
                          variant={
                            currentPage === page
                              ? "dark"
                              : "light"
                          }
                          onClick={() =>
                            setCurrentPage(page)
                          }
                        >
                          {page}
                        </Button>

                      </div>
                    );
                  })}

                {/* NEXT */}

                <Button
                  variant="light"
                  disabled={
                    currentPage === totalPages
                  }
                  onClick={() =>
                    setCurrentPage(currentPage + 1)
                  }
                >
                  ›
                </Button>

              </div>
            )}
          </Card.Body>
        </Card>
      </Container>

      {/* delete model popup */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
